import { graphql } from "react-relay";

export const edit_my_profile = graphql`
  mutation EditMyProfileMutation($input: EditMyProfileInput!) {
    editMyProfile(input: $input) {
      success
      errors
      profile {
        id
        user {
          id
          firstName
          lastName
        }
      }
    }
  }
`;
